module.exports = __webpack_public_path__ + "img/rw.997fe41b.svg";